import React, { useState } from 'react';
import RecentConversationWidget from './widgets/RecentConversationWidget';
import AnalyticsWidget from './widgets/AnalyticsWidget';
import CustomScenariosWidget from './widgets/CustomScenariosWidget';
import ProgressWidget from './widgets/ProgressWidget';
import QuickActionsWidget from './widgets/QuickActionsWidget';
import SkillBreakdownWidget from './widgets/SkillBreakdownWidget';
import SuggestedScenarioWidget from './widgets/SuggestedScenarioWidget';
import StreakTrackerWidget from './widgets/StreakTrackerWidget';
import FeedbackHighlightsWidget from './widgets/FeedbackHighlightsWidget';
import LeadershipBadgesWidget from './widgets/LeadershipBadgesWidget';
import SummaryMetricsWidget from './widgets/SummaryMetricsWidget';
import WeeklyActivityChart from './widgets/WeeklyActivityChart';
import { LayoutDashboard, TrendingUp, BarChart3 } from 'lucide-react';

const iconMap = {
  start: LayoutDashboard,
  progress: TrendingUp,
  analytics: BarChart3,
};

const Dashboard = () => {
  const [view, setView] = useState('start');

  return (
    <div className="p-6 bg-white min-h-screen">
      <h1 className="text-3xl font-bold mb-6">Your Dashboard</h1>

      {/* Filter Toggle */}
      <div className="bg-gray-200 rounded-lg p-1 mb-6 flex gap-2 w-fit">
        {['start', 'progress', 'analytics'].map(option => {
          const Icon = iconMap[option];
          return (
            <button
              key={option}
              onClick={() => setView(option)}
              className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all duration-200 ${
                view === option
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'bg-transparent text-gray-600 hover:bg-white/70'
              }`}
            >
              <Icon className="w-4 h-4" />
              {{
                start: 'Overview & Actions',
                progress: 'Progress Tracking',
                analytics: 'Analytics & Insights',
              }[option]}
            </button>
          );
        })}
      </div>

      {view !== 'analytics' && <SummaryMetricsWidget view={view} />}

      {/* Dynamic View Rendering */}
      {view === 'start' && (
        <div className="flex flex-col gap-6">
          {/* Top full-width widget */}
          <QuickActionsWidget />

          {/* Bottom three-column widgets */}
          <div className="grid gap-6 grid-cols-1 lg:grid-cols-3">
            <div className="flex flex-col gap-6">
              <FeedbackHighlightsWidget />
            </div>
            <div className="flex flex-col gap-6">
              <SuggestedScenarioWidget />
            </div>
            <div className="flex flex-col gap-6">
              <CustomScenariosWidget />
            </div>
          </div>
        </div>
      )}

      {view === 'progress' && (
        <div className="grid gap-6 grid-cols-1 lg:grid-cols-3">
          {/* Left column: Feedback Highlights (1/3 width) */}
          <div className="flex flex-col gap-6">
            <StreakTrackerWidget />
          </div>

          {/* Right columns: Practice Streak (2/3 width) */}
          <div className="flex flex-col gap-6 lg:col-span-2">
            <WeeklyActivityChart />
          </div>
        </div>
      )}


      {view === 'analytics' && (
        <div className="flex flex-col gap-6">
          {/* Full-width badges */}
          <div className="w-full">
            <LeadershipBadgesWidget />
          </div>

          {/* Two-column layout for the remaining widgets */}
          <div className="grid gap-6 grid-cols-1 lg:grid-cols-2">
            <AnalyticsWidget />
            <SkillBreakdownWidget />
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
